export default {
  props: {
    comment: {
      type: String,
      default: '',
    },
    load: {
      type: Boolean,
      load: false,
    },
  },
  data () {
    return {
      infoMessage: 'Click ctrl + enter to save comment',
      errorLengthMax: 'Max characters 500',
      errorLengthMin: 'Min characters 1',
      message: this.infoMessage,
      newComment: this.comment,
    };
  },
  computed: {
    checkCommentLength () {
      if (this.comment.length === 500) {
        this.message = this.errorLengthMax;
        return false;
      }
      if (this.comment.length < 1) {
        this.message = this.errorLengthMin;
        return false;
      }
      this.message = this.infoMessage;
      return true;
    },
  },
};
